import React from 'react';
import { InputNumber as AntInputNumber } from 'antd-v5';
import clearImg from '@/common/images/clear.png';
import './style.less';
function InputNumber(props) {
    const {
        allowClear = true,
        ...nativeProps
    } = props;

    return (
        <AntInputNumber
            allowClear={allowClear ? { clearIcon: <img src={clearImg} alt="clear" style={{ width: 16, height: 16 }} /> } : false}
            {...nativeProps}
            className="ui-input-number"
            controls={false}
        />
    );
}
export default InputNumber;